import * as regex from '@/util/util.regex';

export default function RegexPlugin(Vue) {
  Vue.mixin({
    beforeCreate() {
      this.$regex = regex;
    },
  });
}
